import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import BasketURLCreator from "./BasketURLCreator";
import getUrlParams from "../../utils/getUrlParams";

class DoublestruckInternalTools extends Component {
  state = {
    visible: false
  };

  componentDidMount() {
    const visible = this.dsToolsActive();
    this.setState({ visible });
  }
  dsToolsActive = () => {
    return getUrlParams().dstools;
  };

  render() {
    return (
      <Fragment>
        {this.state.visible && <BasketURLCreator {...this.props} />}
      </Fragment>
    );
  }
}

DoublestruckInternalTools.propTypes = {
  brand: PropTypes.string,
  basket: PropTypes.array
};

export default DoublestruckInternalTools;